// src/runtimeConfig.js
let cfg = null;

// Internal: normalize base path, ensure leading+trailing slash
function normalizeBase(p) {
    if (!p) return '/';
    let base = String(p).trim();
    if (!base.startsWith('/')) base = '/' + base;
    if (!base.endsWith('/')) base = base + '/';
    return base;
}

/**
 * Try to load runtime config (prod first, then dev fallback).
 * If `optional` is true and nothing is found, we don't throw; cfg becomes {}.
 */
export async function loadRuntimeConfig({ optional = true } = {}) {
    if (cfg) return cfg;

    const urls = ['/config/config.json', '/config.dev.json'];
    let lastErr;

    for (const url of urls) {
        try {
            const res = await fetch(url, { cache: 'no-store' });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            cfg = await res.json();
            // Normalize known fields
            if (cfg.basePath) cfg.basePath = normalizeBase(cfg.basePath);
            return cfg;
        } catch (e) {
            lastErr = e;
        }
    }

    if (optional) {
        cfg = {}; // no runtime file available (e.g., staging manual build) – that's OK
        return cfg;
    }

    throw new Error(`Failed to load runtime config (${lastErr})`);
}

export function getRuntimeConfig() {
    if (!cfg) throw new Error('Runtime config not loaded yet');
    return cfg;
}

/**
 * Base path for router/history:
 * 1) runtime cfg.basePath (if present)
 * 2) .env VUE_APP_BASE_PATH (staging build-time)
 * 3) '/'
 */
export function getBasePath() {
    // prefer runtime if available
    const fromRuntime = cfg && cfg.basePath;
    const fromEnv = process.env.VUE_APP_BASE_PATH;
    return normalizeBase(fromRuntime || fromEnv || '/');
}
